import {
    PACKAGES_FEATURES_SEARCH_ROLE_MODULES_RESULT,
    PACKAGES_FEATURES_SEARCH_ROLE_MODULES_REQUEST,
    PACKAGES_FEATURES_SEARCH_ROLE_MODULES_BY_ID_REQUEST,
    PACKAGES_FEATURES_SEARCH_ROLE_MODULES_BY_ID_RESULT,
    PACKAGES_FEATURES_UPDATE_ROLE_MODULES_REQUEST,
    PACKAGES_FEATURES_UPDATE_ROLE_MODULES_RESULT,
    PACKAGES_FEATURES_SET_ROLE_MODULES,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    update: null,
    updateLoading: false,
    loading: false,
    template: null,
    roleModules: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case PACKAGES_FEATURES_SET_ROLE_MODULES:
            return { ...state, template:  action.payload}

        case PACKAGES_FEATURES_SEARCH_ROLE_MODULES_RESULT:
            return { ...state, loading: false, template: action.payload }

        case PACKAGES_FEATURES_SEARCH_ROLE_MODULES_REQUEST:
            return { ...state, loading: true }

        case PACKAGES_FEATURES_SEARCH_ROLE_MODULES_BY_ID_REQUEST:
            return { ...state, loading: true }

        case PACKAGES_FEATURES_SEARCH_ROLE_MODULES_BY_ID_RESULT:
            return { ...state, loading: false, roleModules: action.payload }

        case PACKAGES_FEATURES_UPDATE_ROLE_MODULES_REQUEST:
            return { ...state, updateLoading: true }

        case PACKAGES_FEATURES_UPDATE_ROLE_MODULES_RESULT:
            return { ...state, updateLoading: false, update: action.payload }

        case CLEAR_REDUX:
            return ["", "PACKAGES_FEATURES_TAB"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};